<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        <div class="row">
            <div class="col">
                Generate Employee Letter
            </div>
            <div class="col-auto">
                <button type="button" class="btn btn-outline-primary ms-1" [disabled]="isDisabled"
                    (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed"
                    aria-controls="collapseFilter">
                    <i class="bi bi-caret-down-fill" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Filter':'Loading...'}}
                </button>
            </div>
        </div>
    </div>
    <div class="card-body">
        <div #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed" class="mt-1">
            <form name="FilterForm" (ngSubmit)="FilterValidate(FilterForm)" #FilterForm="ngForm">
                <div class="row m-1">
                    <div class="col-md-4">
                        <label for="Category" class="text-label-dark mb-2">Employee Type</label>
                        <br />
                        @for (EmployeeCategory of common.EmployeeCategorys; track EmployeeCategory.EmployeeCategory;
                        let i =
                        $index) {
                        <label class="form-check-label link-dark px-1" ngbButtonLabel>
                            <input class="form-check-input" type="radio" [value]=EmployeeCategory.Value name='Category'
                                [(ngModel)]="Filter.EmpType" (change)="clear()">
                            {{EmployeeCategory.EmployeeCategory}}
                        </label>
                        }
                        <!-- <label class="form-check-label link-dark px-1" ngbButtonLabel>
                            <input class="form-check-input" type="radio" value='' name='Category'
                                [(ngModel)]="Filter.EmpType" [ngModelOptions]="{standalone: true}">
                            Both
                        </label> -->
                    </div>
                </div>
                <div class="row mx-1">
                    <div class="col-md-4">
                        <label for="BranchID" class="text-label-dark">Branch</label>
                        <ng-select id="BranchID" name="BranchID" [items]="Branchs" bindLabel="BranchName"
                            bindValue="BranchMasterID" placeholder="Branch" [(ngModel)]="this.Filter.BranchID"
                            (change)="ComboLoad('Client');clear()">
                        </ng-select>
                    </div>
                    <div class="col-md-4" *ngIf="Filter.EmpType =='Front'">
                        <label for="ClientId" class="text-label-dark">Client</label>
                        <ng-select id="ClientId" name="ClientId" [items]="Clients" bindLabel="ClientGroupName"
                            bindValue="ClientGroupMasterID" placeholder="Client" [(ngModel)]="this.Filter.ClientID"
                            (change)="ComboLoad('Site');clear()">
                        </ng-select>
                    </div>
                    <div class="col-md-4" *ngIf="Filter.EmpType =='Front'">
                        <label for="SiteId" class="text-label-dark">Site</label>
                        <ng-select id="SiteId" name="SiteId" [items]="Sites" bindLabel="SiteName"
                            bindValue="SiteMasterID" placeholder="Site" [(ngModel)]="this.Filter.SiteID"
                            (change)="clear()">
                        </ng-select>
                    </div>
                </div>
                <div class="row m-1">
                    <div class="col-md-4">
                        <label for="ESS_LetterModuleTypeId" class="text-label-dark">For Employee</label>
                        <ng-select id="ESS_LetterModuleTypeId" name="ESS_LetterModuleTypeId" [items]="EmployeeStatus"
                            bindLabel="ESS_LetterModuleTypeName" bindValue="ESS_LetterModuleTypeId"
                            placeholder="For Employee" [(ngModel)]="this.Filter.ESS_LetterModuleTypeId"
                            (change)="ESSLetterDocumentTypeMasterSelect();clear()" required>
                        </ng-select>
                        <div class="invalid-feedback">
                            Please select for employee!
                        </div>
                    </div>
                    <div class="col-md-4">
                        <label for="LetterTypeId" class="text-label-dark">Letter Type</label>
                        <ng-select id="LetterTypeId" name="LetterTypeId" [items]="LetterTypes"
                            bindLabel="LetterDocumentTypeName" bindValue="ESS_LetterDocumentTypeMasterID"
                            placeholder="Letter Type" [(ngModel)]="this.Filter.LetterTypeId"
                            (change)="ESSLetterTemplateMasterSelect();clear()" required>
                        </ng-select>
                        <div class="invalid-feedback">
                            Please select letter type !
                        </div>
                    </div>
                    <div class="col-md-4">
                        <label for="LetterTemplateId" class="text-label-dark">Letter Template</label>
                        <ng-select id="LetterTemplateId" name="LetterTemplateId" [items]="Templates"
                            bindLabel="LetterName" bindValue="ESS_LetterTemplateMasterID" placeholder="Letter Template"
                            [(ngModel)]="this.Filter.LetterTemplateId" (change)="clear()" required>
                        </ng-select>
                        <div class="invalid-feedback">
                            Please select letter template !
                        </div>
                    </div>
                    <div class="col"></div>
                    <!-- <div class="col-md-2"><br>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" id="isResigned" name="iSResigned"
                                [(ngModel)]="Filter.isResigned">
                            <label class="form-check-label" for="isResigned">Is Resigned</label>
                        </div>
                    </div> -->
                    <div class="col-md-auto align-self-end mt-2">
                        <button class="btn btn-primary" [disabled]="isDisabled"><i class="bi bi-cloud-download me-2"
                                *ngIf="!isDisabled"></i>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                *ngIf="isDisabled"></span>
                            {{!isDisabled?'Apply':'Loading...'}}</button>
                    </div>
                </div>
                <!-- <div class="row m-1">
                    <div class="col"></div>
                    <div class="col-md-auto align-self-end">
                        <button class="btn btn-primary" [disabled]="isDisabled"><i class="bi bi-cloud-download me-2"
                                *ngIf="!isDisabled"></i>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                *ngIf="isDisabled"></span>
                            {{!isDisabled?'Apply':'Loading...'}}</button>
                    </div>
                </div> -->
            </form>
        </div>

        <div class="card-body p-1">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th style="width: 5px;">#</th>
                        <th scope="col" style="width: 65px;"><input class="form-check-input" type="checkbox"
                                id="CheckAll" name="CheckAll" (click)="Check($event,0,true)"> Check</th>
                        <th style="width: 80px;">Code</th>
                        <th>Name</th>
                        <th>Joining Date</th>
                        <th>Work Status</th>
                        <th style="width: 100px;">Status</th>
                        <th>Initiation Date</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let TableData of TableDatas; let i = index">
                        <th scope="row" style="width: 5px;">{{i+1}}</th>
                        <td class="text-center" style="width: 65px;">
                            <div style="width: 65px;"><input class="form-check-input" type="checkbox"
                                    id="IsApprove{{i}}" name="IsApprove{{i}}" (click)="Check($event,i)"
                                    [(ngModel)]="TableData['IsCheck']">
                            </div>
                        </td>
                        <td style="width: 80px;">{{TableData['EmpCode']}}</td>
                        <td>{{TableData['EmployeeName']}}</td>
                        <td>{{TableData['JoiningDate']| date : 'dd MMM yyyy'}}</td>
                        <td>{{TableData['WorkStatusName']}}</td>
                        <td style="width: 50px;">
                            <span class="badge"
                                [ngClass]="{'success': common.ToLowerCase(TableData['ApprovalStatus']) == 'approved', 'danger':common.ToLowerCase(TableData['ApprovalStatus']) == 'rejected','warning':(common.ToLowerCase(TableData['ApprovalStatus']) == 'pending' || common.ToLowerCase(TableData['ApprovalStatus']) == 'initiated')}">{{TableData['ApprovalStatus']}}</span>
                        </td>
                        <td>{{TableData['LetterInitiationDate']}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col"></div>
            <div class="col-auto">
                <button type="button" class="btn btn-outline-primary me-1" [disabled]="isDisabled" ngbTooltip="Cancel"
                    container="body" placement="top" (click)="cancel()">
                    Cancel
                    <span *ngIf="isDisabled" class="spinner-border spinner-border-sm" role="status"
                        aria-hidden="true"></span>
                </button>

                <button type="button" *ngIf="this.common.PageRight.IsAdd"
                    (click)="ESS_LetterTemplateGenerationRequest_InsertUpdate()" class="btn btn-primary"
                    [disabled]="isDisabled"><i class="bi bi-save2" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Generate':'Loading...'}}</button>
            </div>
        </div>
    </div>
</div>